// @ts-nocheck
import * as PIXI from 'pixi.js';

const BASE64 = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
  I: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
  N: 13,
  O: 14,
  P: 15,
  Q: 16,
  R: 17,
  S: 18,
  T: 19,
  U: 20,
  V: 21,
  W: 22,
  X: 23,
  Y: 24,
  Z: 25,
  a: 26,
  b: 27,
  c: 28,
  d: 29,
  e: 30,
  f: 31,
  g: 32,
  h: 33,
  i: 34,
  j: 35,
  k: 36,
  l: 37,
  m: 38,
  n: 39,
  o: 40,
  p: 41,
  q: 42,
  r: 43,
  s: 44,
  t: 45,
  u: 46,
  v: 47,
  w: 48,
  x: 49,
  y: 50,
  z: 51,
  '0': 52,
  '1': 53,
  '2': 54,
  '3': 55,
  '4': 56,
  '5': 57,
  '6': 58,
  '7': 59,
  '8': 60,
  '9': 61,
  '+': 62,
  '/': 63,
};

PIXI.Graphics.prototype.decodePath = function (str: string) {
  const instructions = [this.moveTo, this.lineTo, this.quadraticCurveTo, this.bezierCurveTo, this.closePath];
  const paramCount = [2, 2, 4, 6, 0];
  let i = 0;
  const l = str.length;
  const params = [];
  let x = 0;
  let y = 0;

  while (i < l) {
    const c = str.charAt(i);
    const n = BASE64[c];
    const fi = n >> 3; // highest order bits 1-3 code for operation.
    const f = instructions[fi];
    // check that we have a valid instruction & that the unused bits are empty:
    if (!f || n & 3) {
      throw `bad path data (@${i}): ${c}`;
    }
    const pl = paramCount[fi];
    if (!fi) {
      x = y = 0;
    } // move operations reset the position.
    params.length = 0;
    i++;
    const charCount = ((n >> 2) & 1) + 2; // 4th header bit indicates number size for this operation.
    for (let p = 0; p < pl; p++) {
      let num = BASE64[str.charAt(i)];
      const sign = num >> 5 ? -1 : 1;
      num = ((num & 31) << 6) | BASE64[str.charAt(i + 1)];
      if (charCount === 3) {
        num = (num << 6) | BASE64[str.charAt(i + 2)];
      }
      num = (sign * num) / 10;
      if (p % 2) {
        x = num += x;
      } else {
        y = num += y;
      }
      params[p] = num;
      i += charCount;
    }
    f.apply(this, params);
  }
  return this;
};
